import React from 'react';

export const WorkspaceLoading = () => <div className="mhcw-loading" role="status" aria-live="polite"><span className="mhcw-loading-bar" /><strong>Opening workspace…</strong><span>Your tools are loading.</span></div>;

export const WorkspaceOverlayLoading = ({ label, onClose }) => <div className="mhcw-pending-overlay" role="dialog" aria-modal="true" aria-label={label}><div><button type="button" className="btn btn-light" autoFocus onClick={onClose}>Close</button><WorkspaceLoading /></div></div>;

export default class WorkspaceRouteBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) {
      if (this.props.active === false) return null;
      const message = <section className="mhcw-load-error" role="alert"><h2>This workspace couldn’t open.</h2><p>You can use another section from the menu, or reload this page to try again. Unsaved work on this page may be lost when reloading.</p><button type="button" className="btn btn-dark" onClick={() => window.location.reload()}>Reload this page</button>{this.props.onClose && <button type="button" className="btn btn-light ml-2" onClick={this.props.onClose}>Close</button>}</section>;
      return this.props.onClose ? <div className="mhcw-pending-overlay">{message}</div> : message;
    }
    return this.props.children;
  }
}
